/* global bootstrap */

import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import LanguageContext from "../utils/Contexts/LanguageContext";
import logoDark from "../images/brand-logo-dark.svg";
import logoLight from "../images/brand-logo-light.svg";
import UserContext from "../utils/Contexts/UserContext";
import axiosInstance from "../utils/Requests/axios";
import toast from "react-hot-toast";
import { useCart } from "../utils/Contexts/CartContext";
import { useLocation } from "react-router-dom";
import AccountImage from "../images/account-image.png";

const Header = () => {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const { cartCount, cartLoading } = useCart();

  const handleLogout = () => {
    axiosInstance
      .post("/auth/logout")
      .then(() => {
        window.location.href = "/sign-in";
      })
      .catch(() => {
        toast.error(t("Failed to logout!"));
      });
  };

  const location = useLocation();
  useEffect(() => {
    if (location.pathname.includes("/settings")) {
      const dropdownElement = document.getElementById("accountNavbarDropdown");
      if (dropdownElement) {
        const dropdown =
          bootstrap.Dropdown.getInstance(dropdownElement) ||
          new bootstrap.Dropdown(dropdownElement);
        dropdown.hide();
      }
    }
  }, [location.pathname]);

  return (
    <header
      id="header"
      className="navbar navbar-expand-lg navbar-fixed navbar-height navbar-container navbar-bordered bg-white px-3"
    >
      <div className="navbar-nav-wrap">
        <button
          type="button"
          className="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler border-0 fs-1 list-side-icon"
        >
          <i className="bi-x navbar-toggler-short-align"></i>{" "}
          <i className="bi-list navbar-toggler-full-align"></i>{" "}
        </button>
        <Link
          className="navbar-brand ms-2 ps-2 border-start border-start-2 py-0"
          to=""
          aria-label="Front"
        >
          <img
            className="navbar-brand-logo"
            src={logoLight}
            alt="Backlinks Factory"
            data-hs-theme-appearance="default"
          />
          <img
            className="navbar-brand-logo"
            src={logoDark}
            alt="Backlinks Factory"
            data-hs-theme-appearance="dark"
          />
        </Link>

        <div className="navbar-nav-wrap-content-end">
          <ul className="navbar-nav">
            <div className="notification-panel-lg">
              <li className="nav-item d-inline-block notification-panel-lg">
                <Link
                  to={"/cart"}
                  className="btn btn-ghost-secondary btn-icon rounded-circle btn-cart"
                  style={{ width: "42px" }}
                >
                  {cartCount === null || !!cartLoading ? (
                    <span
                      className="spinner-border spinner-border-sm text-secondary"
                      role="status"
                      aria-hidden="true"
                      style={{ fontSize: "0.75rem" }}
                    ></span>
                  ) : (
                    <>
                      <i className="bi-cart" style={{ fontSize: "13.5px" }}></i>
                      <span
                        className="btn-status btn-md-status btn-status-secondary text-light btn-cart-items-count"
                        style={{ fontSize: "0.55rem" }}
                      >
                        {cartCount}
                      </span>
                    </>
                  )}
                </Link>
              </li>
              <li className="nav-item d-inline-block notification-panel-lg">
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-ghost-secondary btn-icon rounded-circle"
                    id="navbarNotificationsDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                    data-bs-dropdown-animation
                  >
                    <i className="bi-bell" style={{ fontSize: "13.5px" }}></i>
                    <span className="btn-status btn-sm-status btn-status-danger"></span>
                  </button>

                  <div
                    className="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless"
                    aria-labelledby="navbarNotificationsDropdown"
                    style={{ width: "25rem" }}
                  >
                    <div className="card">
                      <div className="card-header card-header-content-between">
                        <h4 className="card-title mb-0">
                          {t("Notifications")}
                        </h4>

                        <div className="dropdown">
                          <button
                            type="button"
                            className="btn btn-icon btn-sm btn-ghost-secondary rounded-circle"
                            id="navbarNotificationsDropdownSettings"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="bi-three-dots-vertical"></i>
                          </button>

                          <div
                            className="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless"
                            aria-labelledby="navbarNotificationsDropdownSettings"
                          >
                            <Link className="nav-link" to="">
                              <span className="dropdown-header">
                                {t("Settings")}
                              </span>
                            </Link>
                            <a className="dropdown-item" href="/offers-search">
                              <i className="bi-archive dropdown-item-icon"></i>{" "}
                              {t("Archive all")}
                            </a>
                            <a className="dropdown-item" href="/offers-search">
                              <i className="bi-check2-all dropdown-item-icon"></i>{" "}
                              {t("Mark all as read")}
                            </a>
                            <a className="dropdown-item" href="/offers-search">
                              <i className="bi-toggle-off dropdown-item-icon"></i>{" "}
                              {t("Disable notifications")}
                            </a>
                            <a className="dropdown-item" href="/offers-search">
                              <i className="bi-gift dropdown-item-icon"></i>{" "}
                              {t("What's new?")}
                            </a>
                            <div className="dropdown-divider"></div>
                            <span className="dropdown-header">
                              {t("Feedback")}
                            </span>
                            <a className="dropdown-item" href="/offers-search">
                              <i className="bi-chat-left-dots dropdown-item-icon"></i>{" "}
                              {t("Report")}
                            </a>
                          </div>
                        </div>
                      </div>

                      <ul
                        className="nav nav-tabs nav-justified"
                        id="notificationTab"
                        role="tablist"
                      >
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            href="#notificationNavOne"
                            id="notificationNavOne-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#notificationNavOne"
                            role="tab"
                            aria-controls="notificationNavOne"
                            aria-selected="true"
                          >
                            {t("Messages")} (3)
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            href="#notificationNavTwo"
                            id="notificationNavTwo-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#notificationNavTwo"
                            role="tab"
                            aria-controls="notificationNavTwo"
                            aria-selected="false"
                          >
                            {t("Archived")}
                          </a>
                        </li>
                      </ul>

                      <div className="card-body-height">
                        <div
                          className="tab-content"
                          id="notificationTabContent"
                        >
                          <div
                            className="tab-pane fade show active"
                            id="notificationNavOne"
                            role="tabpanel"
                            aria-labelledby="notificationNavOne-tab"
                          >
                            <ul className="list-group list-group-flush navbar-card-list-group">
                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck1"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck1"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <img
                                        className="avatar avatar-sm avatar-circle"
                                        src="https://static.articlesfactory.ai/app/img/160x160/img3.jpg"
                                        alt="Description"
                                      />
                                    </div>
                                  </div>
                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Brian Warner</h5>
                                    <p className="text-body fs-5">
                                      {t("changed an issue from")} "In Progress"{" "}
                                      {t("to")}{" "}
                                      <span className="badge bg-success">
                                        {t("Review")}
                                      </span>
                                    </p>
                                  </div>
                                  <small className="col-auto text-muted text-cap">
                                    2hr
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck2"
                                          checked
                                          onChange={() => {}}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck2"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-soft-dark avatar-circle">
                                        <span className="avatar-initials">
                                          K
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Klara Hampton</h5>
                                    <p className="text-body fs-5">
                                      {t("mentioned you in a comment")}
                                    </p>
                                    <blockquote className="blockquote blockquote-sm">
                                      {t(
                                        "Nice work, love! You really nailed it. Keep it up!"
                                      )}
                                    </blockquote>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    10hr
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck3"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck3"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-circle">
                                        <img
                                          className="avatar-img"
                                          src="https://static.articlesfactory.ai/app/img/160x160/img10.jpg"
                                          alt="Description"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Ruby Walter</h5>
                                    <p className="text-body fs-5">
                                      {t("joined the Slack group")} HS Team
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    3dy
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck4"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck4"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-circle">
                                        <img
                                          className="avatar-img"
                                          src="https://static.articlesfactory.ai/app/svg/brands/google-icon.svg"
                                          alt="Description"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">{t("from")} Google</h5>
                                    <p className="text-body fs-5">
                                      {t(
                                        "Start using forms to capture the information of prospects visiting your Google website"
                                      )}
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    17dy
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck5"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck5"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-circle">
                                        <img
                                          className="avatar-img"
                                          src="https://static.articlesfactory.ai/app/img/160x160/img7.jpg"
                                          alt="Description"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Sara Villar</h5>
                                    <p className="text-body fs-5">
                                      {t("completed")}{" "}
                                      <i className="bi-journal-bookmark-fill text-primary"></i>{" "}
                                      FD-7 task
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    2mn
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>
                            </ul>
                          </div>

                          <div
                            className="tab-pane fade"
                            id="notificationNavTwo"
                            role="tabpanel"
                            aria-labelledby="notificationNavTwo-tab"
                          >
                            <ul className="list-group list-group-flush navbar-card-list-group">
                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck6"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck6"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-soft-dark avatar-circle">
                                        <span className="avatar-initials">
                                          A
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Anne Richard</h5>
                                    <p className="text-body fs-5">
                                      {t(
                                        "accepted your invitation to join Notion"
                                      )}
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    1dy
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck7"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck7"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-circle">
                                        <img
                                          className="avatar-img"
                                          src="https://static.articlesfactory.ai/app/img/160x160/img5.jpg"
                                          alt="Description"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Finch Hoot</h5>
                                    <p className="text-body fs-5">
                                      left Slack group HS projects
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    1dy
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck8"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck8"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-secondary avatar-circle">
                                        <span className="avatar-initials">
                                          HS
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Htmlstream</h5>
                                    <p className="text-body fs-5">
                                      {t("you earned a 'Top endorsed'")}{" "}
                                      <i className="bi-patch-check-fill text-primary"></i>{" "}
                                      badge
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    6dy
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck9"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck9"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-circle">
                                        <img
                                          className="avatar-img"
                                          src="https://static.articlesfactory.ai/app/img/160x160/img8.jpg"
                                          alt="Description"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Linda Bates</h5>
                                    <p className="text-body fs-5">
                                      {t("Accepted your connection")}
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    17dy
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>

                              <li className="list-group-item form-check-select">
                                <div className="row">
                                  <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value=""
                                          id="notificationCheck10"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="notificationCheck10"
                                        ></label>
                                        <span className="form-check-stretched-bg"></span>
                                      </div>
                                      <div className="avatar avatar-sm avatar-soft-dark avatar-circle">
                                        <span className="avatar-initials">
                                          L
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col ms-n2">
                                    <h5 className="mb-1">Lewis Clarke</h5>
                                    <p className="text-body fs-5">
                                      {t("completed")}{" "}
                                      <i className="bi-journal-bookmark-fill text-primary"></i>{" "}
                                      FD-134 {t("task")}
                                    </p>
                                  </div>

                                  <small className="col-auto text-muted text-cap">
                                    2mts
                                  </small>
                                </div>

                                {/* eslint-disable-next-line */}
                                <a
                                  className="stretched-link"
                                  href="/offers-search"
                                ></a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <a
                        className="card-footer text-center"
                        href="/offers-search"
                      >
                        {t("View all notifications")}{" "}
                        <i className="bi-chevron-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item d-none d-sm-inline-block notification-panel-lg">
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-icon btn-ghost-secondary rounded-circle"
                    id="navbarAppsDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-dropdown-animation
                  >
                    <i className="bi-app-indicator"></i>
                  </button>

                  <div
                    className="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless"
                    aria-labelledby="navbarAppsDropdown"
                    style={{ width: "25rem" }}
                  >
                    <div className="card">
                      <div className="card-header">
                        <h4 className="card-title">
                          {t("Web apps & services")}
                        </h4>
                      </div>

                      <div className="card-body card-body-height">
                        <a className="dropdown-item" href="/offers-search">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                className="avatar avatar-xs avatar-4x3"
                                src="https://static.articlesfactory.ai/app/svg/brands/atlassian-icon.svg"
                                alt="Description"
                              />
                            </div>
                            <div className="flex-grow-1 text-truncate ms-3">
                              <h5 className="mb-0">Atlassian</h5>
                              <p className="card-text text-body">
                                {t("Security and control across Cloud")}
                              </p>
                            </div>
                          </div>
                        </a>

                        <a className="dropdown-item" href="/offers-search">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                className="avatar avatar-xs avatar-4x3"
                                src="https://static.articlesfactory.ai/app/svg/brands/slack-icon.svg"
                                alt="Description"
                              />
                            </div>
                            <div className="flex-grow-1 text-truncate ms-3">
                              <h5 className="mb-0">
                                Slack{" "}
                                <span className="badge bg-primary rounded-pill text-uppercase ms-1">
                                  Try
                                </span>
                              </h5>
                              <p className="card-text text-body">
                                {t("Email collaboration software")}
                              </p>
                            </div>
                          </div>
                        </a>

                        <a className="dropdown-item" href="/offers-search">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                className="avatar avatar-xs avatar-4x3"
                                src="https://static.articlesfactory.ai/app/svg/brands/google-webdev-icon.svg"
                                alt="Description"
                              />
                            </div>
                            <div className="flex-grow-1 text-truncate ms-3">
                              <h5 className="mb-0">Google webdev</h5>
                              <p className="card-text text-body">
                                {t("Work involved in developing a website")}
                              </p>
                            </div>
                          </div>
                        </a>

                        <a className="dropdown-item" href="/offers-search">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                className="avatar avatar-xs avatar-4x3"
                                src="https://static.articlesfactory.ai/app/svg/brands/frontapp-icon.svg"
                                alt="Description"
                              />
                            </div>
                            <div className="flex-grow-1 text-truncate ms-3">
                              <h5 className="mb-0">{t("Frontapp")}</h5>
                              <p className="card-text text-body">
                                {t("The inbox for teams")}
                              </p>
                            </div>
                          </div>
                        </a>

                        <a className="dropdown-item" href="/offers-search">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                className="avatar avatar-xs avatar-4x3"
                                src="https://static.articlesfactory.ai/app/svg/illustrations/review-rating-shield.svg"
                                alt="Description"
                              />
                            </div>
                            <div className="flex-grow-1 text-truncate ms-3">
                              <h5 className="mb-0">HS {t("Support")}</h5>
                              <p className="card-text text-body">
                                {t("Customer service and support")}
                              </p>
                            </div>
                          </div>
                        </a>

                        <a className="dropdown-item" href="/offers-search">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <div className="avatar avatar-sm avatar-soft-dark">
                                <span className="avatar-initials">
                                  <i className="bi-grid"></i>
                                </span>
                              </div>
                            </div>
                            <div className="flex-grow-1 text-truncate ms-3">
                              <h5 className="mb-0">
                                {t("More Front products")}
                              </h5>
                              <p className="card-text text-body">
                                {t("Check out more")} HS products
                              </p>
                            </div>
                          </div>
                        </a>
                      </div>

                      <a
                        className="card-footer text-center"
                        href="/offers-search"
                      >
                        {t("View all apps")}{" "}
                        <i className="bi-chevron-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </div>
            <li className="nav-item">
              <div className="dropdown">
                {/* eslint-disable-next-line */}
                <a href="javascript:;"
                  className="navbar-dropdown-account-wrapper"
                  id="accountNavbarDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-auto-close="outside"
                  data-bs-dropdown-animation
                >
                  <div className="avatar avatar-sm avatar-circle">
                    <img
                      className="avatar-img profile-img"
                      src={userData?.image_url || AccountImage}
                      alt="Description"
                    />
                    <span className="avatar-status avatar-sm-status avatar-status-success"></span>
                  </div>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account"
                  aria-labelledby="accountNavbarDropdown"
                >
                  <div className="dropdown-item-text">
                    <div className="d-flex align-items-center">
                      <div className="avatar avatar-sm avatar-circle">
                        <img
                          className="avatar-img"
                          src={userData?.image_url || AccountImage}
                          alt="Description"
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h5 className="mb-0">
                          {userData?.first_name} {userData?.last_name}
                        </h5>
                        <p className="card-text text-body">
                          {userData?.username}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-divider"></div>

                  <div className="dropdown">
                    {/* eslint-disable-next-line */}
                    <a href="javascript:;"
                      className="navbar-dropdown-submenu-item dropdown-item dropdown-toggle"
                      id="navSubmenuPagesAccountDropdown1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {t("Set status")}
                    </a>

                    <div
                      className="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-sub-menu"
                      aria-labelledby="navSubmenuPagesAccountDropdown1"
                    >
                      <Link className="dropdown-item" to="/offers-search">
                        <span className="legend-indicator bg-success me-1"></span>{" "}
                        {t("Available")}
                      </Link>
                      <Link className="dropdown-item" to="/offers-search">
                        <span className="legend-indicator bg-danger me-1"></span>{" "}
                        {t("Busy")}
                      </Link>
                      <Link className="dropdown-item" to="/offers-search">
                        <span className="legend-indicator bg-warning me-1"></span>{" "}
                        {t("Away")}
                      </Link>
                      <div className="dropdown-divider"></div>
                      <Link className="dropdown-item" to="/offers-search">
                        {" "}
                        {t("Reset status")}
                      </Link>
                    </div>
                  </div>

                  <Link className="dropdown-item" to="/user/settings/profile">
                    {t("Profile & account")}
                  </Link>
                  <Link className="dropdown-item" to="/user/settings">
                    {t("Settings")}
                  </Link>

                  <div className="dropdown-divider"></div>

                  {userData?.organizations?.map((organization, index) => (
                    <Link
                      className="dropdown-item"
                      to={`/organizations/${organization?.uuid}`}
                      key={index}
                    >
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <div className="avatar avatar-sm avatar-secondary avatar-circle">
                            <span className="avatar-initials">
                              {organization?.name
                                ?.split(" ")
                                .map((item) => item[0])
                                .join("")}
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow-1 ms-2">
                          <h5 className="mb-0">
                            {organization.name}{" "}
                            <span className="badge bg-primary rounded-pill text-uppercase ms-1">
                              {organization.role === 1 ? "OWNER" : "MEMBER"}
                            </span>
                          </h5>
                          <span className="card-text">
                            {organization.domain}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}

                  <div className="dropdown-divider"></div>

                  <div className="dropdown">
                    {/* eslint-disable-next-line */}
                    <a href="javascript:;"
                      className="navbar-dropdown-submenu-item dropdown-item dropdown-toggle"
                      id="navSubmenuPagesAccountDropdown2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {t("Customization")}
                    </a>

                    <div
                      className="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-sub-menu"
                      aria-labelledby="navSubmenuPagesAccountDropdown2"
                    >
                      <Link className="dropdown-item" to="/offers-search">
                        {t("Invite people")}
                      </Link>
                      <Link className="dropdown-item" to="/offers-search">
                        {t("Analytics")}
                        <i className="bi-box-arrow-in-up-right"></i>
                      </Link>
                      <Link className="dropdown-item" to="/offers-search">
                        {t("Customize Front")}
                        <i className="bi-box-arrow-in-up-right"></i>
                      </Link>
                    </div>
                  </div>

                  <Link className="dropdown-item" to="/offers-search">
                    {t("Manage team")}
                  </Link>

                  <div className="dropdown-divider"></div>

                  <Link className="dropdown-item" onClick={handleLogout}>
                    {t("Sign out")}
                  </Link>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
